import { Navigate } from "react-router-dom";
import "./assets/css/main.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Components
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Index";
import About from "./components/About/Index";
import Services from "./components/OurServices/Index";
import Portfolio from "./components/Portfolio/Index";
import EnterpriseERP from "./components/Portfolio/EnterpriseERP/EnterpriseERP";
import AISolutions from "./components/OurServices/AISolutions/AISolutions";
import CustomSoftware from "./components/OurServices/CustomSoftware/CustomSoftware";
import BarcodeManagementSystem from "./components/OurServices/BarcodeManagementSystem/BarcodeManagementSystem";
import BillingSoftware from "./components/OurServices/BillingSoftware/BillingSoftware";
import RetailPosSoftware from "./components/OurServices/RetailPosSoftware/RetailPosSoftware";
import ShopManagementSoftware from "./components/OurServices/ShopManagementSoftware/ShopManagementSoftware";
import SupermarketSoftware from "./components/OurServices/SupermarketSoftware/SupermarketSoftware";
import WarehouseManagementSoftware from "./components/OurServices/WarehouseManagementSoftware/WarehouseManagementSoftware";
import ERP from "./components/OurServices/POSERP/ERP";
import MobileDevelopment from "./components/OurServices/MobileDevelopment/MobileDevelopment";
import Contact from "./components/Contact/index";
import CloudDevOps from "./components/OurServices/CloudDevOps/CloudDevOps";
import InventorySoftware from "./components/OurServices/InventorySoftware/InventorySoftware";
import Footer from "./components/Footer/Footer";
import Terms from "./components/Term/Terms";
import Privacy from "./components/Privacy/Privacy";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop />

      <Routes>
        {/* HOME */}
        <Route path="/" element={<Hero />} />

        {/* MAIN SEO ROUTES */}
        <Route path="/erp-software" element={<EnterpriseERP />} />
        <Route path="/pos-system" element={<ERP />} />
        <Route path="/web-development" element={<Services />} />
        <Route
          path="/barcode-management"
          element={<BarcodeManagementSystem />}
        />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/service" element={<Services />} />

        {/* SERVICE SUB PAGES */}
        <Route path="/ai-solutions" element={<AISolutions />} />
        <Route path="/custom-software" element={<CustomSoftware />} />
        <Route path="/mobile-development" element={<MobileDevelopment />} />
        <Route path="/cloud-devops" element={<CloudDevOps />} />
        <Route path="/inventory-software" element={<InventorySoftware />} />
        <Route path="/billing-software" element={<BillingSoftware />} />
        <Route path="/retail-pos-software" element={<RetailPosSoftware />} />
        <Route path="/supermarket-software" element={<SupermarketSoftware />} />
        <Route
          path="/warehouse-management-software"
          element={<WarehouseManagementSoftware />}
        />
        <Route
          path="/shop-management-software"
          element={<ShopManagementSoftware />}
        />
        {/* OLD ROUTES → CLEAN REDIRECTS */}
        <Route path="/Hero/index" element={<Navigate to="/" replace />} />
        <Route path="/About/index" element={<Navigate to="/about" replace />} />

        <Route
          path="/OurServices/index"
          element={<Navigate to="/web-development" replace />}
        />

        <Route
          path="/OurServices/AISolutions/AISolutions"
          element={<Navigate to="/ai-solutions" replace />}
        />

        <Route
          path="/OurServices/CustomSoftware/CustomSoftware"
          element={<Navigate to="/custom-software" replace />}
        />

        <Route
          path="/OurServices/ERP/ERP"
          element={<Navigate to="/erp-software" replace />}
        />

        <Route
          path="/OurServices/Index"
          element={<Navigate to="/service" replace />}
        />
        <Route
          path="/Portfolio/EnterpriseERP/index"
          element={<Navigate to="/erp-software" replace />}
        />

        <Route
          path="/OurServices/MobileDevelopment/MobileDevelopment"
          element={<Navigate to="/mobile-development" replace />}
        />

        <Route
          path="/OurServices/CloudDevOps/CloudDevOps"
          element={<Navigate to="/cloud-devops" replace />}
        />

        <Route
          path="/Portfolio/index"
          element={<Navigate to="/portfolio" replace />}
        />
        <Route
          path="/Contact/index"
          element={<Navigate to="/contact" replace />}
        />
        <Route path="/Term/terms" element={<Navigate to="/terms" replace />} />
        <Route
          path="/Privacy/privacy"
          element={<Navigate to="/privacy" replace />}
        />
        <Route
          path="/OurServices/InventorySoftware/InventorySoftware"
          element={<Navigate to="/inventory-software" replace />}
        />
        <Route
          path="/OurServices/BarcodeManagementSystem/BarcodeManagementSystem"
          element={<Navigate to="/barcode-management" replace />}
        />
        <Route
          path="/OurServices/BillingSoftware/BillingSoftware"
          element={<Navigate to="/billing-software" replace />}
        />
        <Route
          path="/OurServices/RetailPosSoftware/RetailPosSoftware"
          element={<Navigate to="/retail-pos-software" replace />}
        />
        <Route
          path="/OurServices/SupermarketSoftware/SupermarketSoftware"
          element={<Navigate to="/supermarket-software" replace />}
        />
        <Route
          path="/OurServices/ShopManagementSoftware/ShopManagementSoftware"
          element={<Navigate to="/shop-management-software" replace />}
        />
        <Route
          path="/OurServices/WarehouseManagementSoftware/WarehouseManagementSoftware"
          element={<Navigate to="/warehouse-management-software" replace />}
        />
        {/* 404 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
